import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useParseParams } from '@hooks/params';

import { carFetch, CarFetchPayload } from './action';
import { selectFeatureCar } from './selector';
import { GetIdvCarWithCarIdParams, getIdvCarWithCarIdParamsSchema } from '@apis/CarApi';

export const useCarFetchParams = () => {
  return useParseParams<GetIdvCarWithCarIdParams>(getIdvCarWithCarIdParamsSchema);
};

export const useCarFetch = () => {
  const dispatch = useDispatch();
  const params = useCarFetchParams();
  const { car } = useSelector(selectFeatureCar);

  useEffect(() => {
    if (car && car.id == params.carId) return;
    const payload: CarFetchPayload = params;
    dispatch(carFetch(payload));
  }, [car]);

  return car;
};
